<template>
  <div class="edit-video-box">
    <el-dialog :title="'编辑最热'" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-form-item label="名称:" prop="name">
          <el-input v-model="params.name" size="small"></el-input>
        </el-form-item>
        <el-form-item label="排序:" prop="sortKey">
          <el-input v-model.number="params.sortKey" size="small"></el-input>
        </el-form-item>
        <el-form-item label="封面上传:" prop="cover">
          <base-upload :cover="params.cover" :action="action" @successCallback="successCallback" :wSize="360" :hSize="480" :width="'180px'" :height="'240px'"></base-upload>
        </el-form-item>
        <el-form-item label="状态:">
          <el-switch v-model="params.enable">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import { validatorIndex } from '@/utils/validator'
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      dialogVisible: false,
      flag: false,
      params: {
        targetID: '',
        cover: '',
        sortKey: '',
        name: '',
        enable: false
      },
      // 封面上传地址
      action: baseConfig.baseServerUrl + '/vid/uploadStatic',
      // 验证规则
      rules: {
        name: [{ required: true, message: '请输入标签名称', trigger: 'blur' }],
        sortKey: [
          { required: true, message: '请输入排序', trigger: 'blur' },
          { validator: validatorIndex, trigger: 'blur' }
        ],
        cover: [{ required: true, message: '请上传封面图', trigger: 'blur' }]
      }
    }
  },

  methods: {
    // 数据提交验证
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.editThot()
        } else {
          return false;
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true
      this.params.sortKey = data.sortKey
      this.params.cover = data.cover
      this.params.enable = data.enable
      this.params.name = data.name
      this.params.targetID = data.id
    },
    // 编辑推特短视频最热
    editThot() {
      this.flag = true
      API.editVideoHot(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '编辑成功！',
            type: 'success'
          });
          this.$emit('handlerEdit')
        } else {
          this.$message.error('编辑失败！');
        }
        this.handleClose()
        this.flag = false
      }).catch(() => {
        this.flag = false
        this.handleClose()
      })
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.params.cover = res.data.coverImg
    },
  }

}
</script>

<style lang="scss" >
.edit-video-box {
  .el-input {
    width: 150px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>
